"use client";

import { Box, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import Link from "next/link";

import {
  NavigationEntity,
  useIsSelected,
  useSidebarNavigationEntities,
} from "hooks/useNavigationEntities";

const NavigationTabItem = ({ entity }: { entity: NavigationEntity }) => {
  const isSelected = useIsSelected(entity);

  return (
    <Link href={entity.absolutePath ?? ""} style={{ flex: 1 }}>
      <Flex
        flexDirection="column"
        align="center"
        gap={1}
        px={3}
        py={2}
        borderRadius="xl"
        bg={isSelected ? "sidebar.hover" : "transparent"}
        transition="background 0.15s"
      >
        <Box
          fontSize="lg"
          color={isSelected ? "fg" : "text.secondary"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {entity.icon}
        </Box>
        <Text
          fontSize="xs"
          fontWeight={isSelected ? "bold" : "medium"}
          color={isSelected ? "fg" : "text.secondary"}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxW="full"
        >
          {entity.name}
        </Text>
      </Flex>
    </Link>
  );
};

const NavigationTabs = () => {
  const { root, byId } = useSidebarNavigationEntities();

  return (
    <Flex hideFrom="lg" px={2} py={1} gap={1}>
      {root.children.map((child) => {
        const entity = byId[child.id];
        return <NavigationTabItem key={entity.id} entity={entity} />;
      })}
    </Flex>
  );
};

export default observer(NavigationTabs);
